const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://backend.sortmyspot.com/';
const AUTH_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY0YjI2NjIxNzg3NWZmODNiZDEzYmNkNCIsInJvbGUiOnsiX2lkIjoiNjRiMjY2MjE3ODc1ZmY4M2JkMTNiY2QwIiwibmFtZSI6IlN1cGVyQWRtaW4ifSwiaWF0IjoxNzU5NjYwMjk4fQ.GCNxGMmBfPIJhjJxeOGeB90dZjCPiiAAQamcKrOE6YQ';

// Amenities related API calls
export const amenityServices = {
  // Get all amenities
  getAllAmenities: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/panel/amenity/list`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${AUTH_TOKEN}`
        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('API Error:', response.status, errorData);
        throw new Error(`Failed to fetch amenities: ${response.status}`);
      }

      const data = await response.json();
      console.log('Fetched amenities:', data);
      return data;
    } catch (error) {
      console.error('Error fetching amenities:', error);
      throw error;
    }
  }
};